import { render, staticRenderFns } from "./ReporteScrapMarca.vue?vue&type=template&id=384811ab&scoped=true"
import script from "./ReporteScrapMarca.vue?vue&type=script&lang=js"
export * from "./ReporteScrapMarca.vue?vue&type=script&lang=js"
import style0 from "./ReporteScrapMarca.vue?vue&type=style&index=0&id=384811ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384811ab",
  null
  
)

export default component.exports